const cpfsInvalidos = [
  "00000000000", "11111111111", "22222222222", "33333333333",
  "44444444444", "55555555555", "66666666666", "77777777777",
  "88888888888", "99999999999"
];

export function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  if (cpfsInvalidos.includes(cpf)) {
    return false
  }

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (10 - i);
  }
  let resto = soma % 11;
  const digito1 = resto < 2 ? 0 : 11 - resto;

  if (parseInt(cpf.charAt(9), 10) !== digito1) {
    return false;
  }

  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i), 10) * (11 - i);
  }
  resto = soma % 11;
  const digito2 = resto < 2 ? 0 : 11 - resto;

  if (parseInt(cpf.charAt(10), 10) !== digito2) {
    return false;
  }

  return true;
}

const cnpjsInvalidos = [
  "00000000000000", "11111111111111", "22222222222222",
  "33333333333333", "44444444444444", "55555555555555",
  "66666666666666", "77777777777777", "88888888888888",
  "99999999999999"
];

export function validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
  
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
      return false;
    }

    if (cnpjsInvalidos.includes(cnpj)) {
      return false
    }
  
    const calcularDigito = (cnpj, pesos) => {
      const soma = cnpj
        .slice(0, pesos.length)
        .split('')
        .reduce((acc, digito, i) => acc + parseInt(digito, 10) * pesos[i], 0);
      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };
  
    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  
    const digito1 = calcularDigito(cnpj, pesos1);
    const digito2 = calcularDigito(cnpj + digito1, pesos2);
  
    return (
      parseInt(cnpj.charAt(12), 10) === digito1 &&
      parseInt(cnpj.charAt(13), 10) === digito2
    );
  }
